/* Ambiance Éclat — mémoire des produits consultés.
   Enregistre la fiche courante dans le navigateur du visiteur, puis dessine
   la rangée « Récemment consultés » là où la section est posée.
   Rien ne quitte le navigateur : aucune donnée n'est envoyée au serveur. */
(function () {
  if (window.aeRecemmentVus) return;
  window.aeRecemmentVus = true;

  var CLE = 'ae_recemment_vus';
  var MAX_MEMOIRE = 12;
  var JOURS = 30;

  function lire() {
    try {
      var brut = window.localStorage.getItem(CLE);
      if (!brut) return [];
      var liste = JSON.parse(brut);
      if (!Array.isArray(liste)) return [];
      var limite = Date.now() - JOURS * 86400000;
      return liste.filter(function (p) {
        return p && typeof p.handle === 'string' && typeof p.vu === 'number' && p.vu > limite;
      });
    } catch (e) {
      return [];
    }
  }

  function ecrire(liste) {
    try {
      window.localStorage.setItem(CLE, JSON.stringify(liste.slice(0, MAX_MEMOIRE)));
    } catch (e) {
      /* navigation privée ou stockage refusé : on n'insiste pas */
    }
  }

  function enregistrer() {
    var balise = document.getElementById('ae-produit-vu');
    if (!balise) return;
    var p;
    try {
      p = JSON.parse(balise.textContent);
    } catch (e) {
      return;
    }
    if (!p || !p.handle) return;
    p.vu = Date.now();
    var liste = lire().filter(function (x) {
      return x.handle !== p.handle;
    });
    liste.unshift(p);
    ecrire(liste);
  }

  function texte(valeur) {
    var d = document.createElement('div');
    d.textContent = valeur == null ? '' : String(valeur);
    return d.innerHTML;
  }

  function carte(p) {
    /* Même carte à deux images que les grilles du site : le packshot détouré,
       puis la mise en situation au survol. Les fiches mémorisées avant cette
       version n'ont pas de seconde image : la carte reste simplement fixe. */
    var media = p.image
      ? '<img src="' + texte(p.image) + '" alt="' + texte(p.titre) + '" loading="lazy" width="600" height="600">'
      : '';
    var survol = p.survol
      ? '<span class="ae-rv__survol" aria-hidden="true">' +
        '<img src="' + texte(p.survol) + '" alt="" loading="lazy" width="600" height="600">' +
        '</span>'
      : '';
    var cadrage =
      ' style="--ae-z: ' + texte(p.z == null ? 1 : p.z) +
      '; --ae-x: ' + texte(p.x == null ? 0 : p.x) +
      '%; --ae-y: ' + texte(p.y == null ? 0 : p.y) + '%;"';
    return (
      '<a class="ae-rv__carte" href="' + texte(p.url) + '">' +
      '<span class="ae-rv__media"' + cadrage + '>' + media + survol + '</span>' +
      '<span class="ae-rv__nom">' + texte(p.titre) + '</span>' +
      '<span class="ae-rv__prix">' + texte(p.prix) + '</span>' +
      '</a>'
    );
  }

  function rendre() {
    var hotes = document.querySelectorAll('[data-ae-recemment-vus]');
    if (!hotes.length) return;
    var edition = window.Shopify && window.Shopify.designMode;

    Array.prototype.forEach.call(hotes, function (hote) {
      var exclu = hote.getAttribute('data-exclure') || '';
      var max = parseInt(hote.getAttribute('data-max'), 10) || 4;
      var grille = hote.querySelector('[data-ae-grille]');
      if (!grille) return;

      var liste = lire()
        .filter(function (p) {
          return p.handle !== exclu;
        })
        .slice(0, max);

      if (!liste.length) {
        if (edition) {
          grille.innerHTML = '<p class="ae-rv__vide">Cette rangée affichera les produits que le visiteur a déjà consultés. Elle reste invisible tant qu’il n’en a vu aucun.</p>';
          hote.hidden = false;
        }
        return;
      }

      grille.innerHTML = liste.map(carte).join('');
      hote.hidden = false;
    });
  }

  function demarrer() {
    enregistrer();
    rendre();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  document.addEventListener('shopify:section:load', rendre);
})();
